module.exports = __webpack_public_path__ + "img/level-1.9ef572f4.png";